import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { apiRequest } from "../../lib/request"

export function normalizeInstagramHandleForValidate(input) {
  const s = String(input ?? "").trim()
  if (!s) return ""
  return s.replace(/^@+/, "").trim()
}

/**
 * POST /api/v1/instagram/:handle/validate
 * Empty body (same as curl -d '').
 */
export const validateInstagramHandle = createAsyncThunk(
  "instagramValidate/validateHandle",
  async ({ handle }, { rejectWithValue }) => {
    try {
      const normalized = normalizeInstagramHandleForValidate(handle)
      if (!normalized) {
        return rejectWithValue("Enter a username to validate")
      }

      const url = `/instagram/${encodeURIComponent(normalized)}/validate`
      const response = await apiRequest(url, {
        method: "POST",
      })

      if (response && typeof response === "object" && response.valid === false) {
        return rejectWithValue(
          response.message || response.error || "This Instagram username is not valid",
        )
      }

      return { handle: normalized, response }
    } catch (error) {
      return rejectWithValue(error?.message || "Could not validate Instagram username")
    }
  },
)

const instagramValidateSlice = createSlice({
  name: "instagramValidate",
  initialState: {
    status: "idle",
    error: null,
    lastValidatedHandle: null,
  },
  reducers: {
    resetInstagramValidate: (state) => {
      state.status = "idle"
      state.error = null
      state.lastValidatedHandle = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(validateInstagramHandle.pending, (state) => {
        state.status = "loading"
        state.error = null
      })
      .addCase(validateInstagramHandle.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.lastValidatedHandle = action.payload.handle
        state.error = null
      })
      .addCase(validateInstagramHandle.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })
  },
})

export const { resetInstagramValidate } = instagramValidateSlice.actions
export default instagramValidateSlice.reducer
